import { GtpWalletInfoResult } from '@eika-infrastruktur/mobilbank-lib';

import { useGoogleWalletEligibleCards } from '@domain/digital-wallet';
import { AndroidDigitalWalletCard, Card } from '@generated-types';

const areSameCards = (cardA: Card, cardB: AndroidDigitalWalletCard) => cardA.id === cardB.eikaCardId;

export const useFindDigitalWalletCardQuery = (userCard: Card, googleWalletInfo: GtpWalletInfoResult) => {
    return useGoogleWalletEligibleCards(googleWalletInfo, userCard.type, {
        select: (eligibleCards) => eligibleCards.find((eligibleCard) => areSameCards(userCard, eligibleCard)),
    });
};
